import { Controller, useFormContext, useWatch } from 'react-hook-form';
import {
  DashboardPageFormBody,
  DashboardPageFormField,
  DashboardPageFormToggleSection,
} from '@shigo-ui/dashboard-ui';
import { Input } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { PublisherFormValue } from '../../publisherFormSchema';

export function PublisherSchainFields() {
  'use no memo';
  const { control } = useFormContext<PublisherFormValue>();
  const rewritePublisherId = useWatch({ control, name: 'rewritePublisherId' });
  return (
    <DashboardPageFormBody>
      <Controller
        control={control}
        name="schainAsi"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('publishers.schainAsi')}
            htmlFor="publisher-schain-asi"
            error={fieldState.error?.message}
          >
            <Input {...field} id="publisher-schain-asi" aria-invalid={Boolean(fieldState.error)} />
          </DashboardPageFormField>
        )}
      />
      <Controller
        control={control}
        name="schainSid"
        render={({ field, fieldState }) => (
          <DashboardPageFormField
            label={dashboardT('publishers.schainSid')}
            htmlFor="publisher-schain-sid"
            error={fieldState.error?.message}
          >
            <Input {...field} id="publisher-schain-sid" aria-invalid={Boolean(fieldState.error)} />
          </DashboardPageFormField>
        )}
      />
      <Controller
        control={control}
        name="rewritePublisherId"
        render={({ field }) => (
          <DashboardPageFormToggleSection
            label={dashboardT('publishers.rewritePublisherId')}
            checked={field.value}
            onCheckedChange={field.onChange}
          >
            <Controller
              control={control}
              name="alternativePublisherId"
              render={({ field: inputField, fieldState }) => (
                <DashboardPageFormField
                  label={dashboardT('publishers.alternativePublisherId')}
                  htmlFor="publisher-alternative-id"
                  required={rewritePublisherId}
                  error={fieldState.error?.message}
                >
                  <Input
                    {...inputField}
                    id="publisher-alternative-id"
                    required={rewritePublisherId}
                    aria-invalid={Boolean(fieldState.error)}
                  />
                </DashboardPageFormField>
              )}
            />
          </DashboardPageFormToggleSection>
        )}
      />
    </DashboardPageFormBody>
  );
}
